import React from "react"
import CountUp from "react-countup"
import ReactLoading from "react-loading"
import { useAppSelector } from "@/app/redux/hooks/reduxHooks"

export const SeasonCurrencyComponent = () => {
    const creditsUntilPromotion = useAppSelector((state) => state.dashboard.creditsUntilPromotion)
    const seasonPass = useAppSelector((state) => state.auth.seasonPass)
    return (
        <section className="flex gap-5 py-5">
            <div className="flex-1">
                <h3>SEASON TOTAL</h3>
                <div className="font-bold text-primary text-[24px]">
                    {seasonPass !== null ? (
                        <CountUp end={seasonPass} />
                    ) : (
                        <ReactLoading type={"cylon"} color={"#fff"} height={20} width={20} />
                    )}
                </div>
            </div>
            <div className="flex-1">
                <h3>CREDITS FOR PROMOTION</h3>
                <div className="font-bold text-primary text-[24px]">
                    <CountUp end={creditsUntilPromotion ?? 0} />
                </div>
            </div>
        </section>
    )
}
